import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import './BenefitCard.css';

const BenefitCard = ({
  icon: Icon,
  title,
  description,
  iconColor = '#1B422E',
  titleColor = '#1B422E',
  textColor = '#505050',
  backgroundColor = '#fff',
  elevation = 2,
  hoverElevation = 6,
  iconSize = 50,
  minHeight = '250px'
}) => {
  return (
    <Card
      className="benefit-card"
      sx={{
        height: '100%',
        minHeight: minHeight,
        backgroundColor: backgroundColor,
        borderRadius: '12px',
        transition: 'all 0.3s ease',
        boxShadow: elevation,
        '&:hover': {
          boxShadow: hoverElevation,
          transform: 'translateY(-5px)'
        },
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          p: { xs: 2.5, md: 3 },
          flex: 1
        }}
      >
        {/* Icon */}
        {Icon && (
          <Box
            className="benefit-icon"
            sx={{
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: { xs: 70, md: 80 },
              height: { xs: 70, md: 80 },
              borderRadius: '50%',
              backgroundColor: `${iconColor}15`,
              transition: 'transform 0.3s ease'
            }}
          >
            <Icon
              sx={{
                fontSize: { xs: iconSize - 10, md: iconSize },
                color: iconColor
              }}
            />
          </Box>
        )}

        {/* Title */}
        <Typography
          variant="h3"
          sx={{
            fontFamily: '"Reem Kufi", sans-serif',
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            fontWeight: 600,
            color: titleColor,
            mb: 1.5,
            lineHeight: 1.3
          }}
        >
          {title}
        </Typography>

        {/* Description */}
        <Typography
          variant="body2"
          sx={{
            fontFamily: '"Reem Kufi", sans-serif',
            fontSize: { xs: '0.95rem', md: '1rem' },
            fontWeight: 400,
            color: textColor,
            lineHeight: 1.6
          }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default BenefitCard;
